import daemon from 'springbokjs-daemon';

export default ({ host, localPort = 22, portOnServer = 9022 }) =>
  daemon({
    autoRestart: true,
    command: 'ssh',
    args: [
      '-i',
      '/root/.ssh/pooliot-server',
      '-o',
      'ServerAliveInterval 30',
      '-o',
      'ServerAliveCountMax 3',
      '-NR',
      `${portOnServer}:localhost:${localPort}`,
      host,
    ],
  });
